import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import '../../sass/components/flexibleModules/_components.genericIntroWithGridOverImageSection.scss';
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";

const GenericIntroWithGridOverImageSection = ({ data }) => {

    const [tabSectionVal, setTabSection] = useState(data.genericIntroWithGridOverImageImageSectionWithTabs[0].tabTitle);

    const tabFilter = (tabValue) => {
        setTabSection(tabValue);
    }

    let mediaQueryMax = null;
    let mediaQueryMin = null;
    if (typeof window !== "undefined") {
        mediaQueryMax = window.matchMedia("(max-width: 620px)");
        mediaQueryMin = window.matchMedia("(min-width: 621px)");
    }

    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
    };

    useEffect(() => {
        setIsRendered(true);
    }, []);

    return (
        <div className="cp-genericGridOverImage" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericGridOverImage__inner l--centerAlign" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.genericIntroWithGridOverImageSectionTitle &&
                    <h2 dangerouslySetInnerHTML={{ __html: data.genericIntroWithGridOverImageSectionTitle }} />
                }
                {data.genericIntroWithGridOverImageSectionTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.genericIntroWithGridOverImageSectionTeaser }} />
                }
                {data.genericIntroWithGridOverImageSectionButton &&
                    <a href={data.genericIntroWithGridOverImageSectionButton.url} target={data.genericIntroWithGridOverImageSectionButton.target} className="l-button">{data.genericIntroWithGridOverImageSectionButton.title}</a>
                }
                <div className="cp-genericGridOverImage__tabs">
                    <div className="cp-genericGridOverImage__tabs-inner l--flex">
                        <div className="cp-genericGridOverImage__tabs-left">
                            {data.genericIntroWithGridOverImageImageSectionWithTabs &&
                                <>

                                    {typeof window !== "undefined" &&
                                        <>
                                            {mediaQueryMax.matches ?
                                                <>
                                                    {isRendered &&
                                                        <div className="cp-genericGridOverImage__tabs-slider">
                                                            <Slider {...settings}>
                                                                {
                                                                    data.genericIntroWithGridOverImageImageSectionWithTabs.map((tabSection, index) => (
                                                                        <React.Fragment key={index}>
                                                                            <div className="l-tabSection" key={index}>
                                                                                <button className={tabSection.tabTitle === tabSectionVal ? 'is-active' : ''} onClick={e => tabFilter(e.currentTarget.getAttribute('data-value'))} data-value={tabSection.tabTitle}>
                                                                                    <h3 dangerouslySetInnerHTML={{ __html: tabSection.tabTitle }} />
                                                                                    <div className="l-tabSection-content">
                                                                                        <p dangerouslySetInnerHTML={{ __html: tabSection.tabTeaser }} />
                                                                                        {tabSection.tabLink &&
                                                                                            <a href={tabSection.tabLink.url} target={tabSection.tabLink.target} className="l-textlink">{tabSection.tabLink.title}</a>
                                                                                        }
                                                                                    </div>
                                                                                </button>
                                                                            </div>

                                                                        </React.Fragment>
                                                                    ))
                                                                }
                                                            </Slider>
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {
                                                        data.genericIntroWithGridOverImageImageSectionWithTabs.map((tabSection, index) => (
                                                            <React.Fragment key={index}>
                                                                <div className="l-tabSection" key={index}>
                                                                    <button className={tabSection.tabTitle === tabSectionVal ? 'is-active' : ''} onClick={e => tabFilter(e.currentTarget.getAttribute('data-value'))} data-value={tabSection.tabTitle}>
                                                                        <h3 dangerouslySetInnerHTML={{ __html: tabSection.tabTitle }} />
                                                                        <div className="l-tabSection-content">
                                                                            <p dangerouslySetInnerHTML={{ __html: tabSection.tabTeaser }} />
                                                                            {tabSection.tabLink &&
                                                                                <a href={tabSection.tabLink.url} target={tabSection.tabLink.target} className="l-textlink">{tabSection.tabLink.title}</a>
                                                                            }
                                                                        </div>
                                                                    </button>
                                                                    <div className="l-mobileOnly">
                                                                        {tabSection.tabImage &&
                                                                            <GatsbyImage image={getImage(tabSection.tabImage.gatsbyImage)} alt={tabSection.tabImage.altText} />
                                                                        }
                                                                    </div>
                                                                </div>

                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                </>
                            }
                        </div>
                        <div className="cp-genericGridOverImage__tabs-right">
                            {data.genericIntroWithGridOverImageImageSectionWithTabs.map((tabSection, index) => (
                                <React.Fragment key={index}>
                                    {tabSectionVal === tabSection.tabTitle &&
                                        <>
                                            {tabSection.tabImage &&
                                                <GatsbyImage image={getImage(tabSection.tabImage.gatsbyImage)} alt={tabSection.tabImage.altText} />
                                            }
                                        </>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="cp-genericGridOverImage__grid">
                    <div className="cp-genericGridOverImage__grid-content l--flex">
                        {data.genericIntroWithGridOverImageSectionGridRepeater &&
                            <>
                                {data.genericIntroWithGridOverImageSectionGridRepeater.map((gridRepeat, index) => (
                                    <div className="l-gridSection l--flex" key={index}>
                                        <div className="l-gridSection__inner">
                                            {gridRepeat.icon &&
                                                // <GatsbyImage image={getImage(gridRepeat.icon.gatsbyImage)} alt={gridRepeat.icon.altText ? gridRepeat.icon.altText : ""} />
                                                <img src={gridRepeat.icon.sourceUrl} loading="lazy" alt={gridRepeat.icon.altText} />
                                            }
                                            <h4 dangerouslySetInnerHTML={{ __html: gridRepeat.title }} />
                                            <p dangerouslySetInnerHTML={{ __html: gridRepeat.teaser }} />
                                            {gridRepeat.link &&
                                                <a href={gridRepeat.link.url} target={gridRepeat.link.target} className="l-textLink">{gridRepeat.link.title} <StaticImage src="../../images/arrow-pro-right.svg" alt=""></StaticImage></a>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GenericIntroWithGridOverImageSection;